/* tslint:disable */
/* eslint-disable */
/**
 * residents
 * residents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllResidentsWithNoBills200ResponseData } from './FindAllResidentsWithNoBills200ResponseData';
import {
    FindAllResidentsWithNoBills200ResponseDataFromJSON,
    FindAllResidentsWithNoBills200ResponseDataFromJSONTyped,
    FindAllResidentsWithNoBills200ResponseDataToJSON,
} from './FindAllResidentsWithNoBills200ResponseData';

/**
 * 
 * @export
 * @interface FindAllResidentsWithNoBills200Response
 */
export interface FindAllResidentsWithNoBills200Response {
    /**
     * 
     * @type {FindAllResidentsWithNoBills200ResponseData}
     * @memberof FindAllResidentsWithNoBills200Response
     */
    data?: FindAllResidentsWithNoBills200ResponseData;
}

/**
 * Check if a given object implements the FindAllResidentsWithNoBills200Response interface.
 */
export function instanceOfFindAllResidentsWithNoBills200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllResidentsWithNoBills200ResponseFromJSON(json: any): FindAllResidentsWithNoBills200Response {
    return FindAllResidentsWithNoBills200ResponseFromJSONTyped(json, false);
}

export function FindAllResidentsWithNoBills200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllResidentsWithNoBills200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllResidentsWithNoBills200ResponseDataFromJSON(json['data']),
    };
}

export function FindAllResidentsWithNoBills200ResponseToJSON(value?: FindAllResidentsWithNoBills200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllResidentsWithNoBills200ResponseDataToJSON(value.data),
    };
}

